import { render, staticRenderFns } from "./HeaderTitle.vue?vue&type=template&id=405424d3&scoped=true&"
import script from "./HeaderTitle.vue?vue&type=script&lang=js&"
export * from "./HeaderTitle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "405424d3",
  null
  
)

export default component.exports